import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { api } from "helpers/api_url";

export const fetchItems = createAsyncThunk(
  "item/fetchItems",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }
    console.log("sort : ", sort);
    if (filters && filters.length > 0) {
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            // Handle date range filters
            if (typeof filterValue === "object" && filterValue !== null) {
              if (filterField === "created_at") {
                if (filterValue.from_date) {
                  params.append("created_at_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("created_at_to", filterValue.to_date);
                }
              } else if (filterField === "updated_at") {
                if (filterValue.from_date) {
                  params.append("updated_at_from", filterValue.from_date);
                }
                if (filterValue.to_date) {
                  params.append("updated_at_to", filterValue.to_date);
                }
              } else {
                // Handle other object filters
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              }
            } else {
              // Handle primitive values (string, number)
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }

    const response: any = await Axios.get(`/master/item/?${params.toString()}`);
    console.log("itemResponse : ", filters);
    console.log("itemResponse : ", response);
    // const response: any = await Axios.get(`/item/`, {
    //   params: {
    //     page,
    //     page_size: pageSize,
    //     search: search || undefined,
    //     filters: filters ? JSON.stringify(filters) : undefined,
    //   },
    // });
    return {
      data: response?.data?.data || [],
      rowCount: response?.data?.count || 0,
    };
  }
);

export const fetchItemById = createAsyncThunk(
  "item/fetchById",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(`/master/item/${id}/get/`);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GP by ID");
    }
  }
);

export const fetchItemByDropDown = createAsyncThunk(
  "Item/fetchByDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/master/Item/dropdown/`);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Item list");
    }
  }
);

// Fetch items dropdown (for enquiry/item details forms)
export const fetchItemDropdownForForms = createAsyncThunk(
  "Item/fetchItemDropdownForForms",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/item/dropdown/`);
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || response.data?.item_name || [];
      return data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Item dropdown");
    }
  }
);

// Fetch items by subcategory ID (for enquiry/item details forms)
export const fetchItemsBySubCategoryId = createAsyncThunk(
  "Item/fetchItemsBySubCategoryId",
  async (subCategoryId: string, { rejectWithValue }) => {
    try {
      const response = await Axios.get(`/item/by-subcategory/?sub_category_id=${subCategoryId}`);
      const data = Array.isArray(response.data)
        ? response.data
        : response.data?.data || response.data?.item_name || [];
      return data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch Items by SubCategory");
    }
  }
);

// Fetch items dropdown by category and subcategory (for dispatch forms)
export const fetchItemsByCategoryAndSubCategory = createAsyncThunk(
  "Item/fetchItemsByCategoryAndSubCategory",
  async (
    { categoryId, subCategoryId }: { categoryId: string; subCategoryId: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await Axios.get(
        `/master/item/dropdown/category/${categoryId}/sub-category/${subCategoryId}`
      );
      const list = response.data?.data || [];
      const items = list.map((item: any, idx: number) => ({
        name: item.item_name,
        code: item.item_code,
        id: item.item_id || idx,
        unit: item?.unit?.unit_name,
        unit_id: item?.unit?.unit_id,
      }));
      return items;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch Items by Category and SubCategory"
      );
    }
  }
);

// Fetch bag numbers dropdown by item_name, category_name, sub_category_name, and warehouse_id
export const fetchBagNoDropdown = createAsyncThunk(
  "Item/fetchBagNoDropdown",
  async (
    {
      item_name,
      category_name,
      sub_category_name,
      warehouse_id,
    }: {
      item_name?: string;
      category_name?: string;
      sub_category_name?: string;
      warehouse_id?: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const params = new URLSearchParams();
      if (item_name) params.append("item_name", item_name);
      if (category_name) params.append("category_name", category_name);
      if (sub_category_name) params.append("sub_category_name", sub_category_name);
      if (warehouse_id) params.append("warehouse_id", warehouse_id);

      const response = await Axios.get(
        `${api.warehouse.item_inward.bag_dropdown}?${params.toString()}`
      );
      return response.data?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch bag numbers"
      );
    }
  }
);


export const updateItem = createAsyncThunk(
  "item/updateItem",
  async ({id, payload}: {id: string, payload: any}, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `/master/item/${id}/update/`,
        payload
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update Item");
    }
  }
);

export const updateStatusInItem = createAsyncThunk(
  "item/updateStatusInItem",
  async (itemData: any, { rejectWithValue }) => {
    try {
      const payload = { is_active: itemData.is_active };
      const response: any = await Axios.patch(
        `/master/item/update-status/${itemData.id}`,
        payload
      );

      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GP");
    }
  }
);

export const addItem = createAsyncThunk(
  "item/addItem",
  async (itemData: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(`/master/item/create/`, itemData);
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to add GP");
    }
  }
);

//Exports csv file
// Exports department CSV file
export const exportItemCSV = createAsyncThunk(
  "item/exportItemCSV",
  async (_, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };
      // Use responseType: 'blob' to get the file as a blob
      const response = await Axios.get("/master/item/?export=csv", {
        headers,
        responseType: "blob",
      });
      // Return the blob and filename (if any)
      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "item.csv",
      };
    } catch (err: any) {
      console.error("Export CSV error:", err);
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);

export const exportItemCSV_v2 = async ({
  search,
  filters,
}: {
  search?: string;
  filters?: any;
}) => {
  const params = new URLSearchParams();

  params.append("export", "excel");

  if (search) params.append("search", search);

  if (filters && filters.length > 0) {
    filters.forEach(
      ({
        filterField,
        filterValue,
      }: {
        filterField: string;
        filterValue: any;
      }) => {
        if (filterField && filterValue !== undefined && filterValue !== null) {
          if (typeof filterValue === "object" && filterValue !== null) {
            // Handle date filters
            if (
              (filterValue.from_date || filterValue.to_date) &&
              (filterField === "created_at" || filterField === "updated_at")
            ) {
              if (filterField === "created_at") {
                if (filterValue.from_date) {
                  params.append("created_at_from", String(filterValue.from_date));
                }
                if (filterValue.to_date) {
                  params.append("created_at_to", String(filterValue.to_date));
                }
              } else if (filterField === "updated_at") {
                if (filterValue.from_date) {
                  params.append("updated_at_from", String(filterValue.from_date));
                }
                if (filterValue.to_date) {
                  params.append("updated_at_to", String(filterValue.to_date));
                }
              }
            } else {
              // Handle other object filters
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
              });
            }
          } else {
            params.append(filterField, filterValue);
          }
        }
      }
    );
  }

  const response = await Axios.get(`/master/item/?${params.toString()}`, {
    responseType: "blob",
  });

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[0]
        ?.replace(/"/g, "") || "item.csv",
  };
};
